/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Discount_DetailsInputs */

const en_admin_discounts_discount_details = /** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount Details`)
};

const de_admin_discounts_discount_details = /** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatt-Details`)
};

const es_admin_discounts_discount_details = /** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del descuento`)
};

const fr_admin_discounts_discount_details = /** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de la réduction`)
};

const nl_admin_discounts_discount_details = /** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kortingsdetails`)
};

/** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */
const it_admin_discounts_discount_details = en_admin_discounts_discount_details;

/** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */
const pt_br2_admin_discounts_discount_details = en_admin_discounts_discount_details;

/** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */
const pl_admin_discounts_discount_details = en_admin_discounts_discount_details;

/** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */
const hu_admin_discounts_discount_details = en_admin_discounts_discount_details;

/** @type {(inputs: Admin_Discounts_Discount_DetailsInputs) => LocalizedString} */
const ro_admin_discounts_discount_details = en_admin_discounts_discount_details;

/**
* | output |
* | --- |
* | "Discount Details" |
*
* @param {Admin_Discounts_Discount_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_discount_details = /** @type {((inputs?: Admin_Discounts_Discount_DetailsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Discount_DetailsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_discount_details(inputs)
	if (locale === "de") return de_admin_discounts_discount_details(inputs)
	if (locale === "es") return es_admin_discounts_discount_details(inputs)
	if (locale === "fr") return fr_admin_discounts_discount_details(inputs)
	if (locale === "nl") return nl_admin_discounts_discount_details(inputs)
	if (locale === "it") return it_admin_discounts_discount_details(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_discount_details(inputs)
	if (locale === "pl") return pl_admin_discounts_discount_details(inputs)
	if (locale === "hu") return hu_admin_discounts_discount_details(inputs)
	return ro_admin_discounts_discount_details(inputs)
});
export { admin_discounts_discount_details as "admin.discounts.discount_details" }